module.exports = __webpack_public_path__ + "img/H-Punta180_ok.0f71facf.png";